export default "__VITE_ASSET__DWS1UekT__"